import { DataConnector, DataConnectorType, FtpService } from '../domainObjects/dataConnector';
import { DataFarmType } from '../domainObjects/dataFarmType';
import { DataSourceType } from '../domainObjects/dataSourceType';

export class DataConnectorViewModel<T> {
    dataSourceType: DataSourceType;
    dataConnectorType: DataConnectorType;
    inputFileName?: string ;
    delimiter: string='|';
    inputFileNameExcel?: string;
    sheetName?: any;
    sheets?: any;
    isConnectionValid:boolean=false;
    isUseFtp:boolean=false;
    ftpService: FtpService;

    
    validate(): boolean {
      return false;
    }

    toDataConnector(): T {
      return null;
    }
}
